<template>
  <page>
    <v-container fluid grid-list-sm>
      <message :messages="messages"></message>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl3 lg6 xs6>
                          <v-autocomplete
                            :items="scrRefList"
                            item-text="label"
                            item-value="value"
                            v-model="filters.scrRef"
                            :label="labels.scrRef"
                            :error-messages="errors.collect('scrRef')"
                            data-vv-name="scrRef"
                            :data-vv-as="labels.scrRef"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xl3 lg6 xs6>
                          <v-text-field
                            v-model="filters.txtRef"
                            :label="labels.txtRef"
                            :error-messages="errors.collect('txtRef')"
                            data-vv-name="txtRef"
                            :data-vv-as="labels.txtRef"
                            v-validate="'max:40'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNewDefTxt()"> New Default Text<v-icon right>mdi-plus</v-icon> </v-btn>
        </v-card-title>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="totalItems"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            :loading="loading"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td>{{ getScrRefTxt(row.item.scrRef) }}</td>
                <td class="text-xs-left">{{ row.item.txtRef }}</td>
                <td class="text-xs-left">{{ row.item.txtTitle }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    query
                    @query="doQuery(row.item)"
                    review
                    @review="doReview(row.item)"
                    remove
                    @remove="doRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
        <confirm ref="confirmDelete">
          Are you sure you want to delete the selected Default Text? ({{ selectedScrRef }} - {{ selectedTxtRef }} - {{ selectedTxtTitle }})
        </confirm>
      </v-card>
    </v-container>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { listMixin } from '@/mixins/listMixin'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Clause',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'clause' }
        },
        {
          text: 'Document Heading Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docHdgTxtList' }
        },
        {
          text: 'Document No. Format',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docNoForm' }
        },
        {
          text: 'Seq No., Various',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docNoSeq' }
        },
        {
          text: 'Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'stdRiskTxtList' }
        }
      ],
      headers: [
        { text: 'Screen Reference', value: 'scrRef' },
        { text: 'Text Reference', value: 'txtRef' },
        { text: 'Text Title', value: 'txtTitle' },
        TableConst.tableActionHeader
      ],
      labels: {
        scrRef: 'Screen Reference',
        txtRef: 'Text Reference',
        txtTitle: 'Text Title'
      },
      filters: {
        scrRef: undefined,
        txtRef: undefined
      },
      totalItems: 0,
      loading: false,
      selectedDeftxt: undefined,
      selectedScrTxt: undefined,
      selectedTxtRef: undefined,
      selectedTxtTitle: undefined,
      selectedScrRef: undefined,
      scrRefList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    docFormatMenu() {
      return this.$store.state.docFormatParam.menu
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    async doInit() {
      this.fetchData()
      this.scrRefInit()
    },
    getScrRefTxt(srcRef) {
      return this.scrRefList.find((a) => Number(srcRef) === Number(a.value)).label
    },
    async fetchData() {
      let apiUrl = this.docFormatMenu.getDefTextList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((defTxt) => {
                const convertDefText = {
                  scrRef: defTxt.scrRef,
                  txtRef: defTxt.txtRef,
                  txtTitle: defTxt.txtTitle
                }
                this.items.push(convertDefText)
              })
            }
          } else {
            this.items = []
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.filters.scrRef = null
      this.filters.txtRef = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doReview(data) {
      this.$router.push({ name: 'defTextDet', params: { id: data.scrRef + '_' + data.txtRef, tranMode: 'Review' } })
    },
    doNewDefTxt() {
      this.$router.push({ name: 'defTextDet', params: { id: 'new', tranMode: 'New' } })
    },
    async doRemove(data) {
      const apiURI = this.docFormatMenu.deleteDefText
      if (apiURI) {
        const expand = { data }
        this.selectedScrRef = data.scrRef
        this.selectedTxtRef = data.txtRef
        this.selectedTxtTitle = data.txtTitle
        const prompt = await this.$refs.confirmDelete.doPopUp()
        if (prompt) {
          this.$http
            .delete(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.doInit()
              this.$router.push({ name: 'defText' })
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    async scrRefInit() {
      const apiUrl = this.docFormatMenu.getScrRef
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          this.scrRefList = []
          if (data) {
            // this.scrRefList = result.data.data.scrRefList
            data.scrRefList.map((item) => {
              const scrList = {
                value: item.value,
                label: item.value + ' - ' + item.label
              }
              this.scrRefList.push(scrList)
            })
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doQuery(data) {
      this.$router.push({ name: 'defTextDet', params: { id: data.scrRef + '_' + data.txtRef, tranMode: 'Query' } })
    }
  },
  components: {
    // Keep for further need or enhancement
    //   SideFunctionMenu
  },
  mixins: [TableConst.default, listMixin, MessageMixin]
}
</script>
